import { WizardStepName } from 'data/ppoints/constants';

import { GtmEvent } from '../../enum/gtm-event';
import { GtmAction } from '../gtm-action';
import { GtmVariableKey } from '../gtm-variable-key';

export type SetupGuideStepDoneGtmActionPayload = {
    [GtmVariableKey.name]: WizardStepName;
    [GtmVariableKey.skipped]: boolean;
};

export class SetupGuideStepDoneGtmAction implements GtmAction {
    event = GtmEvent.setup_guide_step_done;

    constructor(public payload: SetupGuideStepDoneGtmActionPayload) {}
}
